import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { config } from "../../configuration/app/app-config"
import { accessToken } from "../../configuration/token/accessToken"
import { assetListSchema, toAssetsList } from "./mfhApi.model"
import { AssetList } from "../../model/asset/asset"

const url = config.mfhApi.baseUrl

export const mfhApi = createApi({
    reducerPath: "mfhApi",
    baseQuery: fetchBaseQuery({
        baseUrl: url,
        prepareHeaders: (headers) => {
            headers.set("authorization", `Bearer ${accessToken.getAccessToken()}`)
            headers.set("accept", "application/json")
            return headers
        },
    }),
    endpoints: (builder) => ({
        getPaginatedAssets: builder.infiniteQuery<AssetList, void, AssetsPageParam>({
            infiniteQueryOptions: {
                initialPageParam: {
                    limit: 1000,
                },
                getNextPageParam: (
                    lastPage,
                ) => {
                    const nextPageUrl = lastPage?.nextPageUrl
                    if (!nextPageUrl) {
                        return undefined
                    }
                    const urlParams = new URLSearchParams(nextPageUrl)
                    return {
                        limit: parseInt(urlParams.get("limit") || "1000"),
                        after: urlParams.get("after") || undefined,
                    }
                },
            },
            query({ pageParam }) {
                return `/assets?status=active${pageParam.after ? `&after=${pageParam.after}` : ""}&limit=${pageParam.limit}`
            },
            transformResponse: (response) => {
                const parsed = assetListSchema.parse(response)
                return toAssetsList(parsed)
            }
        }),
    }),
})
type AssetsPageParam = {
    limit: number
    after?: string
}
export const {
    useGetPaginatedAssetsInfiniteQuery
} = mfhApi
